import type { KnowledgeWeek } from './knowledge';
import type { AgentTaskBrief, SkillAgent } from './skillAgents';
import { post, request } from '../api';

/** Mirrors `apps/api/src/overview/overview.service.ts` (ADR-0009). */

export interface TaskBrief {
  id: string;
  key: string;
  title: string;
  status: string;
  business: { id: string; name: string };
}

export interface Ticket {
  id: string;
  code: string;
  title: string;
  status: string;
  area: string | null;
  since: string;
}

export interface TicketMove {
  id: string;
  code: string;
  title: string;
  from: string;
  to: string;
  at: string;
}

export interface CalendarEvent {
  title: string;
  start: string;
  end?: string;
  allDay?: boolean;
  url?: string;
  location?: string;
}

export interface OverviewData {
  generatedAt: string;
  today: {
    date: string;
    timeZone: string;
    calendar: { observedAt: string; events: CalendarEvent[] } | null;
    deadlines: Array<TaskBrief & { dueAt: string; overdue: boolean }>;
    nowCount: number;
  };
  waiting: Array<TaskBrief & { createdAt: string; from: { kind: 'dialog' | 'inbox' | 'agent'; id: string; title: string } | null }>;
  sviteya: null | {
    connected: boolean;
    businessId: string;
    baseUrl: string | null;
    lastSyncAt: string | null;
    lastError: string | null;
    total: number;
    counts: Record<string, number>;
    onOlena: Ticket[];
    moved: TicketMove[];
    created: Ticket[];
    longestInReview: Ticket[];
  };
  dialogs: {
    counts: { working: number; waiting_human: number; done: number; stale: number };
    rows: Array<{ id: string; title: string; tool: 'claude_code' | 'cowork' | 'claude_ai'; business: { id: string; name: string } | null; state: 'working' | 'waiting_human' | 'done' | 'stale'; lastActivityAt: string; openQuestions: number }>;
  };
  stuck: Array<TaskBrief & { lastMoveAt: string; days: number }>;
  inbox: {
    counts: { new: number; needs_human: number; done: number; trash: number; sortedToday: number };
    needsHuman: Array<{ id: string; title: string | null; source: string; triageNote: string | null; capturedAt: string }>;
  };
  directions: Array<{
    business: { id: string; name: string; status: string };
    projects: Array<{ id: string | null; name: string | null; now: number; next: number; later: number; nextTask: { id: string; key: string; title: string } | null }>;
  }>;
  knowledge: KnowledgeWeek | null;
  /** «Агенти» (ADR-0011); null without agent.read. */
  agents: Array<SkillAgent & { currentTask: AgentTaskBrief | null }> | null;
}

export const overviewApi = {
  get: () => request<OverviewData>('/overview'),
  connectSviteya: (businessId: string, baseUrl: string) => post<{ authorizeUrl: string }>('/sviteya/connect', { businessId, baseUrl }),
};
